import script from "./CompetencyGridsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetencyGridsCard.vue?vue&type=script&setup=true&lang=js"

import "./CompetencyGridsCard.vue?vue&type=style&index=0&id=462f1438&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462f1438"]])

export default __exports__